import {addMethod, string} from 'yup';

addMethod(string, 'emailWithSuffix', function emailWithSuffix(message = 'Invalid email address.') {
  return this
    .email(message)
    .test('email-with-suffix', message, value => {
      if (value == null || value === '') {
        return true;
      }

      const atIndex = value.lastIndexOf('@');

      if (atIndex <= 0 || atIndex === value.length - 1) {
        return false;
      }

      const domain = value.slice(atIndex + 1);

      if (!domain.includes('.')) {
        return false;
      }

      if (domain.startsWith('.') || domain.endsWith('.')) {
        return false;
      }

      return true;
    });
});

export default defineNuxtPlugin(() => {});
